import dayjs from 'dayjs';
import styled from 'styled-components';

import ArrowBackSvg from '../../../assets/icons/arrow-back.svg';
import ArrowNextSvg from '../../../assets/icons/arrow-next.svg';
import {getRem} from '../../../styles';
import {Text} from '../../../uikit/Text';
import {headerButton, headerContainer} from '../styles';

const HeaderContainer = styled.div`
  ${headerContainer};
`;
const Button = styled.button`
  ${headerButton};
`;
const Date = styled(Text).attrs({variant: 'h2'})`
  @container (max-width: 290px) {
    font-size: ${getRem(20)};
  }
`;

export const CustomHeader = ({
  date,
  decreaseMonth,
  increaseMonth,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
}) => {
  return (
    <HeaderContainer>
      <Button disabled={prevMonthButtonDisabled} onClick={decreaseMonth}>
        <ArrowBackSvg />
      </Button>
      <div>
        <Date>{dayjs(date).format('MMMM YYYY')}</Date>
      </div>
      <Button disabled={nextMonthButtonDisabled} onClick={increaseMonth}>
        <ArrowNextSvg />
      </Button>
    </HeaderContainer>
  );
};
